// In-memory on purpose: the intro plays on every page load (refresh included),
// but not again when navigating between pages inside the app.
let seen = false;

export function splashPending() {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return false;
  }
  return !seen;
}

export function markSplashSeen() {
  seen = true;
}
